/* eslint-disable eag/match-named-export */
import {z} from '@hono/zod-openapi';

export const publicHeaders = z.object({
  'x-request-id': z.string().uuid().openapi({
    description: 'Unique request identifier for tracing and logging',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export const publicHeadersWithContent = z.object({
  'content-type': z.enum(['application/json', 'application/json; charset=utf-8'], {
    errorMap: () => ({
      message:
        'Content-Type header must be application/json or application/json; charset=utf-8. We do not support other content types.',
    }),
  }),
  'content-length': z.string().min(1, 'Content-Length header is required'),
  'x-request-id': z.string().uuid().openapi({
    description: 'Unique request identifier for tracing and logging',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export const authHeaders = z.object({
  authorization: z.string().min(1, 'Authorization header is required'),
  'x-request-id': z.string().uuid().openapi({
    description: 'Unique request identifier for tracing and logging',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export const authHeadersWithContent = z.object({
  authorization: z.string().min(1, 'Authorization header is required'),
  'content-type': z.enum(['application/json', 'application/json; charset=utf-8'], {
    errorMap: () => ({
      message:
        'Content-Type header must be application/json or application/json; charset=utf-8. We do not support other content types.',
    }),
  }),
  'content-length': z.string().min(1, 'Content-Length header is required'),
  'x-request-id': z.string().uuid().openapi({
    description: 'Unique request identifier for tracing and logging',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export const s2sHeaders = z.object({
  authorization: z.string().min(1, 'Authorization header is required'),
  'x-request-id': z.string().uuid().optional().openapi({
    description: 'Unique request identifier for tracing and logging',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export const s2sHeadersWithContent = z.object({
  authorization: z.string().min(1, 'Authorization header is required'),
  'content-type': z.enum(['application/json', 'application/json; charset=utf-8'], {
    errorMap: () => ({
      message:
        'Content-Type header must be application/json or application/json; charset=utf-8. We do not support other content types.',
    }),
  }),
  'content-length': z.string().min(1, 'Content-Length header is required'),
  'x-request-id': z.string().uuid().optional().openapi({
    description: 'Unique request identifier for tracing and logging',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});
